import React from "react";
import { Link } from "react-router-dom";
// Images
import ITLogo from "../../../Assets/Veleučilište/Veleuciliste-logo.png";

export default function NotFoundPage() {
  const handleClick = (path) => {
    window.scrollTo(0, 0);
  };

  return (
    <>
      <div className="section error-page">
        <div>
          {" "}
          <img src={ITLogo} alt="Veleuciliste IT" />
          <h2>STRANICA NIJE PRONAĐENA!</h2>
          <p>Provjerite putanju koju ste upisali.</p>
          <Link className="btn" to="/" onClick={() => handleClick("/")}>
            NATRAG NA NASLOVNU
          </Link>
        </div>
      </div>
    </>
  );
}
